fragment AdminFragment on Admin {
    id
    name
    email
    email_verified
    email_verified_at
    setup_completed
    setup_completed_at
    newsletter_opt_in_requested_at
    locale
    tenant_role {
        id
        name
        is_system
    }
    tenants {
        ...TenantFragment
    }
}
